import React from "react";
import { Routes, Route } from "react-router-dom";
import AboutPage from "../pages/AboutPage";
import AboutusPage from "../pages/AboutusPage";
import ContactPage from "../pages/ContactPage";
import HomePage from "../pages/HomePage";
import ProductPage from "../pages/ProductPage";
import QuestionPage from "../pages/QuestionPage";
import ProductDetailsPage from "../pages/ProductDetailsPage";
import ProductSimilarPage from "../pages/ProductSimilarPage";
import ContactusPage from "../pages/ContactusPage";
import ProductSimilarGidaPage from "../pages/ProductSimilarCamasirsulariPage";
import SidebarPage from "../pages/SidebarPage";
import CamasirSuyuPage from "../pages/CamasirSuyuPage";
import KirecCozucuPage from "../pages/KirecCozucuPage";
import UltraKivamliCamasirSuyuPage from "../pages/UltraKivamliCamasirSuyuPage";
import SanayiTipiYagCozucuPage from "../pages/SanayiTipiYagCozucuPage";
import BulasikDeterjaniLuksPage from "../pages/BulasikDeterjaniLuksPage";
import BulasikMakinaDeterjanıPage from "../pages/BulasikMakinaDeterjanıPage";
import BulasikMakinaParlaticisiPage from "../pages/BulasikMakinaParlaticisiPage";
import WcBanyoTemizleyiciPage from "../pages/WcBanyoTemizleyiciPage";
import BulasikDeterjaniEkstraPage from "../pages/BulasikDeterjaniEkstraPage";
import YuzeyTemizlikMaddesiPage from "../pages/YuzeyTemizlikMaddesiPage";
import SiviElSabunuPage from "../pages/SiviElSabunuPage";
import SiviElKopukPage from "../pages/SiviElKopukPage";
import BulasikMakinaDeterjaniProPage from "../pages/BulasikMakinaDeterjaniProPage";
import ProductSimilarBulasikMakineDeterjanlariPage from "../pages/ProductSimilarBulasikMakineDeterjanlariPage";
import ProductSimilarCamasirsulariPage from "../pages/ProductSimilarCamasirsulariPage";
import BulasikMakinaParlaticisiProPage from "../pages/BulasikMakinaParlaticisiProPage";
import SiviElSabunuMaviPage from "../pages/SiviElSabunuMaviPage";
import ProductSimilarsiviElSabunlariPage from "../pages/ProductSimilarsiviElSabunlariPage";
import GaleriPage from "../pages/GaleriPage";

const CustomRoutes = () => {
  return (
    <Routes>
      
      <Route exact path="/Sidebar" element={<SidebarPage />} />
      <Route exact path="/camasirsuyu" element={<CamasirSuyuPage />} />
      <Route exact path="/kireccozucu" element={<KirecCozucuPage />} />
      <Route exact path="/wcbanyotemizleyici" element={<WcBanyoTemizleyiciPage />} />
      <Route exact path="/ultrakivamlicamasirsuyu" element={<UltraKivamliCamasirSuyuPage />} />
      <Route exact path="/sanayitipiyagcozucu" element={<SanayiTipiYagCozucuPage />} />
      <Route exact path="/bulasikdeterjaniluks" element={<BulasikDeterjaniLuksPage />} />
      <Route exact path="/bulasikdeterjaniekstra" element={<BulasikDeterjaniEkstraPage />} />
      <Route exact path="/yuzeytemizlikmaddesi" element={<YuzeyTemizlikMaddesiPage />} />
      <Route exact path="/sivielsabunu" element={<SiviElSabunuPage />} />
      <Route exact path="/sivielsabunumavi" element={<SiviElSabunuMaviPage />} />
      <Route exact path="/sivielkopuk" element={<SiviElKopukPage />} />
      <Route exact path="/bulasikmakina" element={<BulasikMakinaDeterjanıPage />} />
      <Route exact path="/bulasikmakinapro" element={<BulasikMakinaDeterjaniProPage />} />
      <Route exact path="/bulasikmakinaparlaticisi" element={<BulasikMakinaParlaticisiPage />} />
      <Route exact path="/bulasikmakinaparlaticisipro" element={<BulasikMakinaParlaticisiProPage />} />
      <Route exact path="/bulasikmakinadeterjanipro" element={<BulasikMakinaDeterjaniProPage />} />
      <Route exact path="/bulasikmakinedeterjanlari" element={<ProductSimilarBulasikMakineDeterjanlariPage />} />
      
      <Route path="/bizeulasin" element={<ContactusPage />} />

      <Route
        exact
        path="/ProductSimilarCamasirsulari"
        element={<ProductSimilarCamasirsulariPage />}
      />

      <Route
        exact
        path="/productsimilarsivielsabunlari"
        element={<ProductSimilarsiviElSabunlariPage />}
      />
      

      <Route exact path="/ProductSimilar" element={<ProductSimilarPage />} />
      <Route exact path="/ProductDetails" element={<ProductDetailsPage />} />
      <Route exact path="/Question" element={<QuestionPage />} />
      {/* <Route exact path="/TopBar" element={<TopBarPage />} /> */}
      <Route exact path="/urunlerimiz" element={<ProductPage />} />
      <Route path="/iletisim" element={<ContactPage />} />
      <Route path="/kurumsal" element={<AboutusPage />} />
      <Route path="/hakkimizda" element={<AboutPage />} />
      <Route exact path="/galeri" element={<GaleriPage />} />
      <Route path="/" element={<HomePage />} />
    </Routes>
  );
};

export default CustomRoutes;
